<template>
<div class="chapter">
<div class="inner_page">
<p class="epi"><a id="epigraph">Tempt not the stars, young man; thou canst not play With the severity of fate. . . . In thy aspect I note A consequence of danger.</a></p><a id="epigraph">
<p class="att">—from <span class="txit">The Broken Heart</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?f3771ada